import React from 'react';

import { useEntitlements } from '../../contexts';
import { Select } from '../../components/ui';
import { PAYMENT_METHOD_OPTIONS } from '../paymentMethods';

import './payment-type.scss';

const normalise = (value) => {
  // Legacy: stripe_card was used in earlier flows where a card payment came
  // through Stripe Elements (admin manually entered). Map to 'card' for the
  // UI so the dropdown shows the right method.
  if (value === 'stripe_card') return 'card';
  return value || 'offline';
};

// `allowedMethods`: when provided, restricts the options to that subset —
// pass MANUAL_PAYMENT_METHODS (../paymentMethods) on Commissions, EXPERT FEES
// and the /sell flow.
//
// A dropdown rather than the old pill row: with six methods the pills no
// longer fit next to currency / amount / date / bank on one payment row.
export function PaymentType({ value, onChange, readOnly, allowedMethods }) {
  const active = normalise(value);
  const { hasFeature } = useEntitlements();
  const visible = (allowedMethods
    ? PAYMENT_METHOD_OPTIONS.filter((opt) => allowedMethods.includes(opt.value))
    : PAYMENT_METHOD_OPTIONS
  ).filter(
    // Keep an option that is already the recorded method, even if the plan no
    // longer includes it — a historic Stripe payment must still render as
    // what it was, not silently re-label itself as a bank transfer.
    (opt) => !opt.feature || hasFeature(opt.feature) || active === opt.value
  );

  return (
    <div className="payment-type">
      <Select
        label="Payment method"
        data-btn="payment-toggle-method"
        options={visible.map((opt) => ({ value: opt.value, label: opt.label }))}
        value={active}
        disabled={readOnly}
        searchable={false}
        fullWidth
        onChange={(next) => {
          if (readOnly) return;
          if (active === next) return;
          onChange(next);
        }}
      />
    </div>
  );
}
